import React, { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import BestSellers from "@/components/site/BestSellers";
import ColorLineup from "@/components/site/ColorLineup";
import Difference from "@/components/site/Difference";
import BundleBanner from "@/components/site/BundleBanner";
import Reviews from "@/components/site/Reviews";
import Sizing from "@/components/site/Sizing";
import JoinClub from "@/components/site/JoinClub";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import SearchOverlay from "@/components/site/SearchOverlay";
import { useCart } from "@/context/CartContext";
import { toast } from "@/hooks/use-toast";

export default function Home() {
  const [cartOpen, setCartOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const { add } = useCart();

  const handleAdd = (p) => {
    add(p);
    toast({
      title: "Added to cart",
      description: `${p.color} · ${p.name}`,
    });
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="bg-white min-h-screen">
      <Header
        onOpenCart={() => setCartOpen(true)}
        onOpenSearch={() => setSearchOpen(true)}
      />
      <Hero onShop={() => scrollTo("shop")} onBundles={() => scrollTo("collections")} />
      <TrustBar />
      <BestSellers onAdd={handleAdd} />
      <ColorLineup />
      <Difference />
      <BundleBanner onAdd={handleAdd} />
      <Reviews />
      <Sizing />
      <JoinClub />
      <Footer />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  );
}
